<template>
  <div>
    <div class="voucher-inner-wrap">

      <voucher-banner bannerId="voucher_index"/>

      <div class="select-voucher">
        <p class="select-voucher-hd1">
          <span>이용권을 선택해주세요.</span>
        </p>
        <p class="select-voucher-hd2">매월 자동결제 / 부가세포함</p>
      </div>

      <template v-if="dataList">
        <all-product-category v-for="(category, index) in dataList"
                              :key="index"
                              :category="category"
                              :categoryNum="index"
                              :current-index="currentIndex"
        />
      </template>
    </div>
    <voucher-remind/>
    <div class="sticky-wrap">
      <div class="sticky-box">
        <span class="sticky-name-box">
          <span class="sticky-product-name">{{currentProductName}}</span>
          <span class="sticky-product-desc">{{currentDescription}}</span>
        </span>
        <span class="sticky-price-box">
          <span class="sticky-product-price">
            <span>{{setNumberCommas(currentPrice)}}원</span>
          </span>
          <span class="sticky-product-btn" @click="voucherPurchase()">구매하기</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import AllProductCategory from '@/components/voucher/AllProductCategory'
import VoucherRemind from '@/components/voucher/VoucherRemind'
import VoucherBanner from '@/components/voucher/VoucherBanner'
import { showBillingPopup, setNumberCommas, setDisableScrolling } from '@/common/utils/common'
import { getFromUrl } from '@/common/utils/request'
import _ from 'lodash'
export default {
  components: {
    AllProductCategory,
    VoucherRemind,
    VoucherBanner
  },
  data () {
    return {
      dataList: [],
      currentProductName: '',
      currentDescription: '',
      currentPrice: '',
      concurrencyCount: 1,
      currentProduct: {},
      currentIndex: 'group_00_0'
    }
  },
  methods: {
    setNumberCommas (price) {
      return setNumberCommas(price)
    },
    goGuide () {
      let tempTop = document.getElementById('bottomGuide').offsetTop + 260
      window.scroll(0, tempTop)
    },
    setData (list) {
      this.currentProduct = _.get(list, ['concurrency', '0'], {})
      this.currentProductName = _.get(this.currentProduct, 'product_name', '')
      this.currentDescription = _.get(this.currentProduct, 'description', '')
      this.currentPrice = _.get(this.currentProduct, 'amount', '')
      this.concurrencyCount = _.get(this.currentProduct, 'concurrency_count', '')
    },
    voucherPurchase () {
      const isExternal = _.get(this.currentProduct, 'is_product_external', 'n').toUpperCase() === 'Y'
      const linkTarget = _.get(this.currentProduct, 'external_link_target', '')
      const externalUrl = _.get(this.currentProduct, 'external_link_pc', '')
      if (isExternal) {
        window.open(externalUrl, linkTarget)
      } else {
        let locationOrign = window.location.origin
        if (!locationOrign) locationOrign = window.location.protocol + '//' + window.location.hostname

        showBillingPopup({ productId: this.currentProduct.productid, productType: 'all', returnUrl: locationOrign + '/callback.html?action=ClosePopup', canceledUrl: locationOrign + '/callback.html?action=Cancel' })
      }
    },
    currentVoucher (list, indexInfo) {
      this.currentIndex = indexInfo
      this.setData(list)
    }
  },
  created () {
    getFromUrl({ url: 'pooq3-static-json.pooq.co.kr/service/passlist/purchase-products-all_201911.json' }).then((response) => {
      this.dataList = response.data
      this.setData(_.get(this.dataList, ['0', 'productgroups', '0', 'products', '0'], []))
    })
    setDisableScrolling(false)
    this.$nextTick(() => {
      this.$events.$on('selectedVoucher', this.currentVoucher)
      this.$events.$on('goGuide', () => {
        this.goGuide()
      })
    })
  },
  beforeDestroy () {
    this.$events.$off('goGuide')
    this.$events.$off('selectedVoucher')
  }
}
</script>
<style lang="css" src="@/assets/css/ticket.css"></style>
